import {decompress} from 'shrink-string';
import elementComponentNameMap from '../../components/customComponents/appViewer/utils/uiRenderUtils/elementComponentNameMap';
import elementLazyLoadMap from '../../components/customComponents/appViewer/utils/uiRenderUtils/elementLazyLoadMap';

export const setAppViewerReducer = (data={}) => dispatch => {
    dispatch({
        type : 'SET_APP_VIEWER_REDUCER',
        payload : data
    });
    // data = null;
    // dispatch = null;
}

export const setAppViewerAppObject = (data={}) => dispatch => {
    dispatch({
        type : 'SET_APP_VIEWER_APP_OBJECT',
        payload : data
    });
    // data = null;
    // dispatch = null;
}

export const removeAppViewerAppObject = (data={}) => dispatch => {
    dispatch({
        type : 'REMOVE_APP_VIEWER_APP_OBJECT',
        payload : data
    });
    // data = null;
    // dispatch = null;
}

export const setViewerElementAppData = (params={}) => dispatch => {
    dispatch({
        type : 'SET_VIEWER_ELEMENT_APP_DATA',
        payload : {
            data : params['data'],
            elementId : params['elementId'],
            refresh : params['refresh'] ? true : false,
            clearCache : params['clearCache'],
            appId : params['appId']
        }
    });
    // params = null;
    // dispatch = null;
}

export const initializeAppViewerApp = (data={}) => dispatch => {
    dispatch({
        type : 'INITIALIZE_APP_VIEWER_APP',
        payload : data
    });
    // data = null;
    // dispatch = null;
}

export const setAppviewerDataInReducer = (payload={}) => dispatch => {
    dispatch({
        type : 'SET_APP_VIEWER_DATA_IN_REDUCER',
        payload
    });
    // payload = null;
    // dispatch = null;
}

export const setViewerAppData = (data={}, appId='', updateSettings=false, silentUpdate=false) => dispatch => {
    if(updateSettings){
        dispatch({
            type : 'SET_VIEWER_APP_SETTINGS',
            payload : {
                data,
                appId,
                silentUpdate
            }
        });
    }else{
        dispatch({
            type : 'SET_VIEWER_APP_DATA',
            payload : {
                data,
                appId,
                silentUpdate
            }
        });
    }

    // data = null;
    // appId = null;
    // updateSettings = null;
    // silentUpdate = null;
    // dispatch = null;
}

export const getWebsiteResources = (request={}) => async dispatch => {
    try{
        if(
            !request.hasError &&
            !request.error
        ){
            let {compressedResources=''} = request;
            let decompressed = await decompress(compressedResources);
            let parsedBuild = JSON.parse(decompressed);
            let {
                appId='', appElementsMap={}, appFunctionMap={},
                parsedPageMap={}
            } = parsedBuild;
            dispatch({
                type : 'SET_WEBSITE_RESOURCES',
                payload : {
                    appId,
                    resources : {
                        appElementsMap,
                        appFunctionMap,
                        parsedPageMap
                    }
                }
            });

            compressedResources = null;
            decompressed = null;
            parsedBuild = null;
            appId = null;
            appElementsMap = null;
            appFunctionMap = null;
        }

        // dispatch = null;
        request = null;
    }catch(e){
        console.log('/appViewerActions getWebsiteResources catch block error', e);
    }
}

export const getWebsitePageResources = (request={}) => async dispatch => {
    try{
        if(
            !request.hasError &&
            !request.error
        ){
            let {compressedResources=''} = request;
            let decompressed = await decompress(compressedResources);
            let parsedBuild = JSON.parse(decompressed);
            let {
                appId='', appElementsMap={}, appFunctionMap={},
                pageMap={}
            } = parsedBuild;
            dispatch({
                type : 'SET_WEBSITE_PAGE_RESOURCES',
                payload : {
                    appId,
                    resources : {
                        appElementsMap,
                        appFunctionMap,
                        pageMap
                    }
                }
            });

            compressedResources = null;
            decompressed = null;
            parsedBuild = null;
            appId = null;
            appElementsMap = null;
            appFunctionMap = null;
        }

        // dispatch = null;
        request = null;
    }catch(e){
        console.log('/appViewerActions getWebsitePageResources catch block error', e);
    }
}

export const setViewerWebComponent = (params={}) => async dispatch => {
    let {
        app={}, appId='', appInFocusId=''
    } = params;
    dispatch({
        type : 'SET_VIEWER_WEB_COMPONENT',
        payload : {
            appId,
            app,
            appInFocusId
        }
    });
    params = null;
    app = null;
    appId = null;
    appInFocusId = null;
    // dispatch = null;
}

export const updateGenericElementCacheInReducer = (params={}) => dispatch => {
    dispatch({
        type : 'UPDATE_GENERIC_ELEMENT_CACHE_IN_REDUCER',
        payload : {
            data : params['data'],
            elementId : params['elementId'],
            field : params['field']
        }
    });
    // params = null;
    // dispatch = null;
}

export const setBatchComputeCache = (payload={}) => dispatch => {
    dispatch({
        type : 'SET_BATCH_COMPUTE_CACHE',
        payload
    });
    // payload = null;
    // dispatch = null;
}

export const unsetBatchComputeCache = (key='') => dispatch => {
    dispatch({
        type : 'UNSET_BATCH_COMPUTE_CACHE',
        payload : {
            key
        }
    });
    // key = null;
    // dispatch = null;
}

export const setQuickUpdateDataCache = (payload={}) => dispatch => {
    dispatch({
        type : 'SET_QUICK_UPDATE_DATA_CACHE',
        payload
    });
    // payload = null;
    // dispatch = null;
}

export const triggerComponentLoad = (elementType='') => dispatch => {
    dispatch({
        type : 'TRIGGER_COMPONENT_LOAD',
        payload : {
            elementType
        }
    });
}

export const setUiComponentCache = (elementType='') => async dispatch => {
    let refresh = elementLazyLoadMap[elementComponentNameMap[elementType]];
    if(!refresh || typeof refresh !== 'function'){
        console.log('missing element', elementType)
    }
    let elementComponent;
    do{
        elementComponent = await refresh();
        if(
            elementComponent._payload && 
            (elementComponent._payload._status === 2)
        ){
            console.log('ElementComponent retry', elementType, elementComponent && elementComponent._payload);
        }
    }while(
        !elementComponent ||
        (
            elementComponent._payload && 
            (elementComponent._payload._status === 2)
        )
    );
    dispatch({
        type : 'SET_UI_COMPONENT_CACHE',
        payload : {
            elementType,
            elementComponent
        }
    });
    elementType = null;
    elementComponent = null;
    // dispatch = null;
}

export const manageInFocusElementId = (action, id) => dispatch => {
    dispatch({
        type : 'MANAGE_IN_FOCUS_ELEMENT_ID',
        payload : {
            action,
            id
        }
    });
}

export const setInFocusElementId = (payload={}) => dispatch => {
    dispatch({
        type : 'SET_IN_FOCUS_ELEMENT',
        payload
    });
}

export const updateEfficientFileManagerMap = (params={}) => dispatch => {
    dispatch({
        type : 'UPDATE_EFFICIENT_FILE_MANAGER_MAP',
        payload : {
            data : params['data'],
            appId : params['appId']
        }
    });
}

export const setUnloadedFontFamilies = (params={}) => dispatch => {
    dispatch({
        type : 'SET_UNLOADED_FONT_FAMILIES',
        payload : {
            fontFamilyList : params['fontFamilyList']
        }
    });
}